import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import _ from 'lodash';

import { formatServerDateTime, formatDisplayDate, parseDisplayDate } from '@/util/MomentUtils';
import showSuccessMessage from '@/util/ShowSuccessMessage';
import showErrorMessage from '@/util/showErrorMessage';
import { validateForm } from '@/util/ParsleyUtils';

import SaveCustomerOrderGeneral from '../../../services/SaveCustomerOrderGeneral';

import tmplWideFormatGeneralView from './WideFormatGeneralView.hbs';

const WideFormatGeneralView = View.extend({
  template: tmplWideFormatGeneralView,

  className: 'wide-format-general-view',

  ui: {
    dateEquipmentReq: 'input[name="dateEquipmentReq"]',
    commandPOC: '#commandPOC',
    generalForm: '.general-form',
    firstName: '#firstName',
    lastName: '#lastName',
    email: '#email',
    telephone: '#telephone'
  },

  events: {
    'change @ui.commandPOC': 'onCommandPOCChange'
  },

  onRender() {
    const order = this.model.get('order');

    this.ui.dateEquipmentReq.datepicker({ format: 'mm/dd/yyyy' });
    if (order.dateEquipmentReq) {
      this.ui.dateEquipmentReq.datepicker('setDate', formatDisplayDate(order.dateEquipmentReq));
    }

    order.hasReq = order.hasBaseAccessReq;
    order.accessNotes = order.baseAccessReqNotes;
  },

  async validate() {
    const isReadOnly = this.model.get('isReadOnly');

    try {
      if (isReadOnly) this.ui.generalForm.find(':input').prop('disabled', false);
      await validateForm(this.ui.generalForm);
      this.trigger('no:errors');
      return true;
    } catch {
      if (isReadOnly) {
        this.ui.generalForm.find(':input').prop('disabled', true);
      }
      this.trigger('has:errors');
      return false;
    }
  },

  async onAttach() {
    if (this.model.get('orderDetails').showValidation) {
      await this.validate();
    }
  },

  async onSave() {
    const serialFormData = Syphon.serialize(this);
    if (serialFormData.dateEquipmentReq) {
      const dateEquipmentReq = formatServerDateTime(parseDisplayDate(serialFormData.dateEquipmentReq));
      serialFormData.dateEquipmentReq = dateEquipmentReq;
      const neededMonth = parseInt(serialFormData.dateEquipmentReq.substring(5, 7));
      let numMonthsUntilFYEnd;
      if (neededMonth < 10) {
        numMonthsUntilFYEnd = 10 - neededMonth;
      } else {
        numMonthsUntilFYEnd = 22 - neededMonth;
      }
      serialFormData.numMonthsUntilFYEnd = numMonthsUntilFYEnd;
    }

    const formData = {
      generalFormData: serialFormData,
      orderId: this.model.get('orderDetails').orderId,
      orderTypeId: this.model.get('orderDetails').orderTypeId
    };

    try {
      await SaveCustomerOrderGeneral(formData);

      Object.assign(this.model.get('order'), {
        ...serialFormData,
        hasReq: serialFormData.hasBaseAccessReq,
        accessNotes: serialFormData.baseAccessReqNotes
      });

      this.showSaveSuccess();
    } catch (err) {
      this.showSaveError();
      throw new Error(err);
    }
  },

  onCommandPOCChange() {
    const commandPOCs = this.model.get('orderDetails').commandPOCs;
    const commandId = this.ui.commandPOC.val();

    if (commandId) {
      const command = _.find(commandPOCs, { id: commandId });
      this.$('#firstName').val(`${command.firstName}`);
      this.$('#lastName').val(`${command.lastName}`);
      this.$('#email').val(command.email);
      this.$('#telephone').val(command.telephone);
    } else {
      this.$('#firstName').val('');
      this.$('#lastName').val('');
      this.$('#email').val('');
      this.$('#telephone').val('');
    }
    validateForm(this.ui.generalForm, 'commandPOCInfo');
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occured while saving general information for this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  }
});

export default WideFormatGeneralView;
